import React, { useCallback, useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { uiActions } from '../../actions';
import { generalHelpers } from '../../helpers';
import useSelector from '../../hooks/useSelector';
import { useWebSocketMessageListener } from '../../websocket/hooks';

const Updater: React.FC = () => {
  const [t] = useTranslation();
  const { forceUpdate } = useSelector(state => state.ui.updater);

  const [remainingSec, setRemainingSec] = useState<number>(
    Number.MAX_SAFE_INTEGER
  );

  useEffect(() => {
    if (forceUpdate) {
      setRemainingSec(10);
      setInterval(() => {
        setRemainingSec(sec => sec - 1);
      }, 1000);
    }
  }, [forceUpdate]);

  useEffect(() => {
    if (remainingSec <= 0) {
      window.location.reload();
    }
  }, [remainingSec]);

  // Testing: using WebSocket to push out update
  const dispatch = useDispatch();
  const handleMessage = useCallback(
    message => {
      if (message.action === 'UPDATE_FRONTEND') {
        dispatch(uiActions.updater.forceUpdate());
      }
    },
    [dispatch]
  );
  useWebSocketMessageListener(handleMessage);

  return (
    <Modal show={forceUpdate} centered onHide={generalHelpers.noop}>
      <Modal.Header>
        <Modal.Title>{t('New version available')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{t('new version p 1')}</p>
        <p>{t('new version p 2')}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={() => window.location.reload()}>
          {t('Update')}
          {remainingSec <= 10 && remainingSec >= 0 && ` (${remainingSec}s)`}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Updater;
